import "./Logo.css";
import LogoLight from "../images/logo-light.svg";
// import LogoDark from "../images/logo-dark.svg";

export function Logo() {
  return (
    <div className="logo">
      <img
        src={LogoLight}
        className="logo__image logo__image--light"
        alt="Serova logo"
      />
      {/* <img
        src={LogoDark}
        className="logo__image logo__image--dark"
        alt="Serova logo"
      /> */}
    </div>
  );
}
